// Currency formatting helpers

/**
 * Format number as Indonesian Rupiah (no decimals, dot thousand separators).
 * e.g., 1500000 -> "Rp 1.500.000"
 */
export function formatIDR(amount) {
  const n = Number(amount || 0);
  const rounded = Math.round(n);
  return "Rp " + rounded.toLocaleString("id-ID");
}

/** Compact version without "Rp" prefix. */
export function formatIDRCompact(amount) {
  const n = Math.round(Number(amount || 0));
  return n.toLocaleString("id-ID");
}
